export type AdminIconName =
    | "Announcement"
    | "Event"
    | "MeetingRoom"
    | "Museum"
    | "Contact"
    | "People"
    | "PermMedia"
    | "ShoppingCart"
    | "Account"
    | "ManageAccounts";

export type AdminNavigationItem = {
    title: string;
    dashboardTitle: string;
    description: string;
    iconName: AdminIconName;
    route: string;
};

/**
 * Shared source of truth for every admin entry point (drawer, dashboard and
 * account menu). Keep routes here canonical so links cannot drift apart.
 */
export const ADMIN_NAVIGATION_ITEMS: readonly AdminNavigationItem[] = [
    {
        title: "Medien",
        dashboardTitle: "Medien verwalten",
        description: "Dateien hochladen, Metadaten pflegen oder Medien entfernen",
        iconName: "PermMedia",
        route: "/admin/media",
    },
    {
        title: "Ankündigung",
        dashboardTitle: "Ankündigung bearbeiten",
        description: "Das Ankündigungs-Popup der Startseite bearbeiten",
        iconName: "Announcement",
        route: "/admin/announcement-popup",
    },
    {
        title: "Shop und Produkte",
        dashboardTitle: "Produkte verwalten",
        description: "Produkte im Museums-Shop erstellen, bearbeiten oder entfernen",
        iconName: "ShoppingCart",
        route: "/admin/shop/products",
    },
    {
        title: "Veranstaltungen",
        dashboardTitle: "Veranstaltungen verwalten",
        description: "Veranstaltungen erstellen, bearbeiten oder entfernen",
        iconName: "Event",
        route: "/admin/events",
    },
    {
        title: "Sonderausstellungen",
        dashboardTitle: "Sonderausstellungen verwalten",
        description: "Sonderausstellungen erstellen, bearbeiten und veröffentlichen",
        iconName: "Museum",
        route: "/admin/special-exhibitions",
    },
    {
        title: "Sonderöffnungszeiten",
        dashboardTitle: "Sonderöffnungszeiten verwalten",
        description: "Abweichende Öffnungs- und Schließzeiten pflegen",
        iconName: "MeetingRoom",
        route: "/admin/special-opening-hours",
    },
    {
        title: "Team",
        dashboardTitle: "Team verwalten",
        description: "Teammitglieder hinzufügen, bearbeiten oder entfernen",
        iconName: "People",
        route: "/admin/team",
    },
    {
        title: "Kontakt",
        dashboardTitle: "Kontaktdaten verwalten",
        description: "Adresse, Telefonnummer und Erreichbarkeiten verwalten",
        iconName: "Contact",
        route: "/admin/contact",
    },
] as const;

export function adminTitleForPath(pathname: string): string {
    if (pathname.startsWith("/admin/account")) return "Mein Konto";
    if (pathname.startsWith("/admin/users")) return "Benutzer/Rollen";
    return ADMIN_NAVIGATION_ITEMS.find(({ route }) => pathname.startsWith(route))?.title
        ?? "Dashboard";
}
